<template>
    <el-row>
        <el-form :model="accountForm"
                 ref="accountManageRef"
                 :rules="rules"
                 addAction="/businessIntranet/refundLegalAccount.action"
                 editAction="/businessIntranet/refundLegalAccount.action"
                 label-width="150px"
                 style="width:40%"
                 v-form>

          <el-form-item label="账号类型:" prop="accountType">
            <el-select v-model="accountForm.accountType">
              <el-option label="扣除人脉次数" :value="1" ></el-option>
              <el-option label="扣除线索次数" :value="2"></el-option>
              <el-option label="扣除车商群数" :value="3"></el-option>
            </el-select>
          </el-form-item>
          
            <el-form-item label="扣除次数：" prop="count">
                <el-input type="number" v-model="accountForm.count"  placeholder="请输入扣除次数"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'accountManage',
  extends: BasicPager,
  components: { EmployeeSelect },
  data: function () {
    let checkDecima = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('请填写大于0的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }
      callback()
    }
    return {
      rules: {
        count: [{
          required: true,
          message: '请输入扣除次数'
        },
        { validator: checkDecima, trigger: 'blur' }
        ]
      },
      accountForm: {
        businessId: null,
        accountType: 1,
        count: null

      }
    }
  },
  created () {
    this.accountForm.businessId = this.$route.query.businessId
  },
  methods: {
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {

    }
  }

}
</script>

<style scoped>

</style>
